import React, { FC } from 'react';
import { GameFamily, useGameFamilies } from '../../config/gameFamilyConfig';

import classes from './GameFamilies.module.scss';
import { useNewUser } from '../../hooks/useNewUser';
/**
 * List of game family thumbnails (ccson, castles, sea, koenigsburg).
 */

interface GameFamiliesProps {
  onSelectFamily?: (family: GameFamily) => void;
  showTitle?: boolean;
}

const GameFamilies: FC<GameFamiliesProps> = ({ onSelectFamily, showTitle = true }) => {
  const isNewUser = useNewUser();
  const filteredFamilies = /* isNewUser ? gameFamilies.filter((gf) => gf.type !== 'ccson') : */ useGameFamilies();

  return (
    <div className={classes.mainCont}>
      {filteredFamilies.map((gf) => (
        <div
          className={classes.familyItem}
          key={gf.type}
          onClick={() => {
            onSelectFamily?.(gf);
          }}>
          {showTitle && (
            <div className={classes.header}>
              <div
                className={classes.title}
                onClick={() => {
                  onSelectFamily?.(gf);
                }}>
                {gf.title}
              </div>
            </div>
          )}
          <img
            className={`${classes.thumbnail}${gf.type === 'chess' ? ' ' + classes.chess : ''}`}
            src={'./static/public/media/' + gf.src}
          />
        </div>
      ))}
    </div>
  );
};

export default GameFamilies;
